import { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ROUTES } from '@/constants/routes'
import { STORAGE_KEYS } from '@/constants/auth'
import { useAuth } from '@/contexts/authContext'

export function PaymentSuccessPage() {
  const { t } = useTranslation('wizard')
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { refreshAuth } = useAuth()

  useEffect(() => {
    const token = searchParams.get('token')

    if (token) {
      localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, token)
      refreshAuth()

      const timeoutId = setTimeout(() => {
        navigate(ROUTES.DASHBOARD)
      }, 2000)

      return () => clearTimeout(timeoutId)
    } else {
      const timeoutId = setTimeout(() => {
        navigate('/')
      }, 2000)

      return () => clearTimeout(timeoutId)
    }
  }, [searchParams, navigate, refreshAuth])

  return (
    <div className="bg-background flex min-h-0 flex-1 flex-col items-center justify-center px-4 py-8">
      <div className="mx-auto max-w-[500px]">
        <div className="rounded-[26px] border border-[#E9E9E9] bg-white px-[54px] py-10">
          <div className="mb-4 flex justify-center">
            <img src="/check.svg" alt="" width={60} height={60} className="h-[60px] w-[60px]" />
          </div>
          <h1 className="text-foreground mb-4 text-center text-xl font-bold">
            {t('paymentSuccess.title')}
          </h1>
          <p className="text-foreground mb-4 text-center text-base font-normal">
            {t('paymentSuccess.subtitle')}
          </p>
          <p className="text-foreground text-center text-sm font-normal">
            {t('paymentSuccess.redirecting')}
          </p>
        </div>
      </div>
    </div>
  )
}
